import React, { useEffect, useCallback } from 'react';
import './assets/App.css';
import { MapPage } from './features/map-dashboard';
import { LoginPage } from './features/auth';
import { InactivityWarning } from './components/InactivityWarning';
import { useAuthStore } from './stores';
import { useInactivityTimeout } from './hooks/useInactivityTimeout';

const INACTIVITY_TIMEOUT = 30 * 60 * 1000; // 30 minutes
const INACTIVITY_WARNING = 5 * 60 * 1000;  // warn at 25 min (5 min before logout)

function App() {
  const { isAuthenticated, checkTokenExpiry, logout } = useAuthStore();

  const handleInactivityTimeout = useCallback(() => {
    logout();
  }, [logout]);

  const { showWarning, secondsLeft, dismissWarning } = useInactivityTimeout({
    timeoutMs: INACTIVITY_TIMEOUT,
    warningMs: INACTIVITY_WARNING,
    onTimeout: handleInactivityTimeout,
    enabled: isAuthenticated,
  });

  useEffect(() => {
    // Check if session is still valid on mount
    if (isAuthenticated) {
      checkTokenExpiry();
    }
  }, [isAuthenticated, checkTokenExpiry]);

  // Proactively refresh the token before it expires
  useEffect(() => {
    if (!isAuthenticated) return;

    const REFRESH_INTERVAL = 4 * 60 * 1000; // Check every 4 minutes
    const interval = setInterval(() => {
      checkTokenExpiry();
    }, REFRESH_INTERVAL);

    return () => clearInterval(interval);
  }, [isAuthenticated, checkTokenExpiry]);

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <>
      <MapPage />
      {showWarning && (
        <InactivityWarning
          secondsLeft={secondsLeft}
          onStay={dismissWarning}
          onLogout={logout}
        />
      )}
    </>
  );
}

export default App;
